import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {DataContentCard} from '../../../../components/DataContentCard';
import {StyledCard, StyledDataContent} from './styles';
import {OpinionCardType} from './types';

const {specialty, opinionDate, footerText} =
	translations['pt-br'].privateFlow.myHospitalization.opinions.card;

export const OpinionCard = ({specialtyName, date, dataTestId}: OpinionCardType) => (
	<StyledCard data-test-id={dataTestId}>
		<StyledDataContent>
			<DataContentCard iconName="stethoscope" title={specialty} description={specialtyName} />
			<DataContentCard
				iconName="query-builder-filled"
				title={opinionDate}
				description={date}
			/>
		</StyledDataContent>

		<Typography variant="body2" color={'text.secondary'}>
			{footerText}
		</Typography>
	</StyledCard>
);
